function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
export default (({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.98 2.05C6.44995 2.05 1.94995 6.54 1.94995 12.07C1.94995 17.6 6.44995 22.09 11.97 22.09C17.49 22.09 21.99 17.59 21.99 12.07C21.99 6.55 17.5 2.05 11.98 2.05ZM10.84 4.14C10.17 7.54 7.46995 10.22 4.05995 10.85C4.58995 7.38 7.35995 4.63 10.84 4.14ZM3.99995 12.88C8.55995 12.23 12.17 8.64 12.87 4.1C16.57 4.51 19.51 7.44 19.94 11.13C15.37 11.82 11.75 15.45 11.11 20.04C7.35995 19.64 4.36995 16.64 3.98995 12.88H3.99995ZM13.15 20C13.77 16.54 16.48 13.81 19.93 13.16C19.45 16.69 16.67 19.49 13.15 20Z",
  fill: fill || 'currentColor'
})));
//# sourceMappingURL=TennisBall.js.map